var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("c-step", {
    attrs: {
      stepperGrpCd: "IIM_ACCIDENT_STEP_CD",
      currentStepCd: _vm.currentStepCd,
      param: _vm.param,
    },
    on: {
      keySetting: _vm.keySetting,
      currentStep: _vm.currentStep,
      closePopup: _vm.closePopup,
    },
    model: {
      value: _vm.stepCd,
      callback: function ($$v) {
        _vm.stepCd = $$v
      },
      expression: "stepCd",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }